import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'apostrofosSyndesmos';
const args = {};

export class ApostrofosSyndesmos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
